import * as Yup from "yup";
import { Persolog_ClassType } from "@relay/persologClassForm_PersologClassFragment.graphql";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createPersologClassFormSchema = (t: TFunc) =>
	Yup.object().shape({
		title: Yup.string().required(t("validation:titleFieldRequired")),
		text: Yup.string().required(t("validation:textFieldRequired")),
		image: Yup.object({
			id: Yup.string().optional(),
			name: Yup.string().optional(),
		}).optional(),
		classType: Yup.mixed<Persolog_ClassType>()
			.oneOf(["D", "G", "I", "S"], t("validation:invalidClassType"))
			.required(t("validation:typeRequired")),
	});
